// extracted by mini-css-extract-plugin
export default {"diamond":"GnrrOJdGgBSJ0NidUT0w","small":"U2Xw50mRbT52d75LlzCQ","unattained":"KPLpRpMhBqyro0QZ9YFM","attained":"lb7TGgkIj4oNdM5kQs7_","label":"aBs79C82KmDjTv8nBH9y"};